<script setup lang="ts">
import { BlockLink } from "@/views/blocks/PageBlock.interface";

const { href, label, textColor } = defineProps<BlockLink & { textColor: string }>();

function handleClick(e: MouseEvent) {
    e.preventDefault();
    const targetElement = document.getElementById(href);

    if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth" });
    }
}
</script>

<template>
    <a :href="href" class="link-item text-sm/6" @click="handleClick">{{ label }}</a>
</template>

<style scoped>
a {
    color: v-bind("textColor");
    border-bottom: 1px solid transparent;
}

a:hover {
    border-bottom: 1px solid v-bind("textColor");
}

a:active {
    border-bottom: 1px solid color-mix(in srgb, v-bind("textColor"), transparent);
}

a:focus-visible {
    outline: 1px dotted v-bind("textColor");
    outline-offset: 2px;
}
</style>
